import { useMemo, memo } from 'react';
import { cn, RawHtml } from '@divlab/divanui';

import ServiceTable from '../ServiceTable';
import styles from './DeliveryTabContent.module.css';

import type { ServiceTablesData } from '@Types/DeliveryTables';
import type { FC, HTMLAttributes } from 'react';

export interface DeliveryTabContentProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  deliveryTables: ServiceTablesData;
}

const DeliveryTabContent: FC<DeliveryTabContentProps> = (props) => {
  const { className, deliveryTables, ...restProps } = props;

  const tableOptions = useMemo(() => {
    const deliveryOptions = deliveryTables.delivery?.content?.map((table) => {
      return table.options;
    });

    const upliftOptions =
      deliveryTables.uplift?.content?.map((table) => {
        return table.options.filter((item) => item.type !== 'UPLIFT_FIRST_FLOOR');
      }) || [];

    return [...deliveryOptions, ...upliftOptions].flat();
  }, [deliveryTables]);

  const upliftFirstFloorOptions = useMemo(() => {
    const filteredOptions =
      deliveryTables.uplift?.content?.map((table) => {
        return table.options.filter((item) => item.type === 'UPLIFT_FIRST_FLOOR');
      }) || [];

    return filteredOptions.flat();
  }, [deliveryTables]);

  return (
    <div {...restProps} className={cn(styles.content, className)}>
      <div className={styles.table}>
        <ServiceTable contentData={tableOptions} />
      </div>

      {deliveryTables.suburb?.content.map((table, index) =>
        table.options.map((option) => (
          <div className={styles.hint} key={index}>
            <RawHtml html={`${option.name}: ${option.price}`} />
          </div>
        )),
      )}

      {upliftFirstFloorOptions.length > 0 && (
        <>
          {deliveryTables.uplift?.title && (
            <div className={styles.hint}>{deliveryTables.uplift.title}</div>
          )}

          <div className={styles.table}>
            <ServiceTable contentData={upliftFirstFloorOptions} />
          </div>
        </>
      )}
    </div>
  );
};

export default memo(DeliveryTabContent);
